import { useState, useEffect } from "react";
import axios from "axios";
import { useClient } from "ClientContext";
import { getDisabledDates } from "utils/getAvailabilitiesConversion";

interface AvailabilitiesProps {
  // Type definition for the processed availability data
  // e.g., an array of dates, or whatever `getDisabledDates` returns
}

export function useFetchSingleAvailability(internal_ID: string, listingId: string,integration_TYPE:string,action:string) {
  const [availability, setAvailability] = useState<AvailabilitiesProps | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  // Access additional data and actions from your context if needed
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    if (!listingId) {
      // If no listingId is provided, do nothing or set defaults
      setAvailability(null);
      setLoading(false);
      return;
    }

    const fetchAvailability = async () => {
      try {
        const fromDate = new Date();
        const toDate = new Date();
        toDate.setMonth(toDate.getMonth() + 12); // 12 months ahead

        // POST request to fetch availability for a single listing
        const response = await axios.post(`${SERVER_URL}/api/controller`, {
          action: action,
          internal_ID,
          params: {
            listingId: listingId,
            availabilities: {
              fromDate: fromDate.toISOString(),
              toDate: toDate.toISOString(),
            },
          },
        });

        // Transform the response according to your function getDisabledDates
        const rawAvailabilities = { availabilities: response.data };
        const processedDates = await getDisabledDates(rawAvailabilities, integration_TYPE);

        // Store the result in state
        setAvailability(processedDates);
      } catch (error) {
        setError(error as Error);
        console.error("Error fetching single listing availability:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAvailability();
  }, [listingId, internal_ID, integration_TYPE, action, SERVER_URL]);

  return { availability, loading,error };
}